export const isNeedDTOForMembers = (groupUsers = []) => groupUsers.some(member => !member.auth0_id && !!member.userId)

export const dtoForMembers = (groupUsers = [], allUsers = []) => 
    groupUsers
        .map(member => allUsers.find(x => x.id === member.userId))
        .filter(x => x)
